<template>
  <view-table
      ref="viewTable"
      :filter="filter"
      module="basic"
      url="applications/getToDoReplacementBillApplicationList"
      :columns-property="columnsProperty"
      :table-select="false"
      @reset="resetHandle">
    <template slot="adSearch">
      <div class="vm-search">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="状态">
            <el-select v-model="filter.isread">
              <el-option label="全部" value=""/>
              <el-option label="已读" :value="1"/>
              <el-option label="未读" :value="0"/>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input v-model.trim="filter.filter" placeholder="请输入关键字" clearable/>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </view-table>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  export default {
    // name: "ReplacementBillApplication",
    components: {ViewTable},
    data() {
      return {
        filter: {
          billType: 14,
          isread: "",
          filter: "",
        },
        columnsProperty: [
          {
            key: "read",
            width: 100,
            align: "center",
            render: (h, params) => {
              return h("span", params.row.read === "1" ? "已读" : "未读");
            },
          },
          {
            key: "billNO",
            width: 140,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.$router.push({
                          path: "/approval",
                          query: {
                            billType: 14,
                            billId: params.row.billID,
                            sequId: params.row.sequID,
                            $tabName: "审批_" + params.row.billNO,
                          },
                        });
                      },
                    },
                  },
                  params.row.billNO,
              );
            },
          },
          {
            key: "customerName",
            minWidth: 300,
          },
          {
            key: "creatorName",
            align: "center",
            width: 120,
          },
          {
            key: "descrpt",
            width: 200,
            align: "center",
          },
          {
            key: "standardTime",
            align: "center",
            width: 120,
            render: (h, params) => {
              return h("span", parseInt(params.row.standardTime) + "分钟");
            },
          },
          {
            key: "lastHandleTime",
            align: "center",
            width: 180,
          },
          {
            key: "wfSubmitedTime",
            align: "center",
            width: 180,
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
